import React from "react"
import { Switch, Route } from 'react-router-dom'
import SnippetInstall from './SnippetInstall'
import WordPress from './WordPressInstall'
import SegmentInstall from './SegmentInstall'
import Verify from './Verify'
import InstallOptions from './InstallOptions'

import "./style.css"

import ProgressMeterWithLogo from 'components/ProgressMeterWithLogo'

import { SNIPPET_TYPES } from './constants'

const OnboardingInstallStep = ({ ...props }) => {
    return (
      <div className="onboarding-install-step">
        <ProgressMeterWithLogo currentLength={props.index} maxLength={props.stepCount - 1}/>
        <Switch>
          <Route exact={true} path={`${props.path}`} render={() => <InstallOptions {...props}/>}/>
          <Route exact={true} path={`${props.path}/js`} render={()=> <SnippetInstall installType={SNIPPET_TYPES.JAVASCRIPT} {...props}/>}/>
          <Route exact={true} path={`${props.path}/segment`} render={()=> <SegmentInstall {...props}/>}/>
          <Route exact={true} path={`${props.path}/wordpress`} render={()=> <WordPress {...props} />}/>
          <Route exact={true} path={`${props.path}/verify`} render={() => <Verify {...props}/>}/>
          <Route exact={true} path={`${props.path}/wordpress/snippet`} render={()=> <SnippetInstall installType={SNIPPET_TYPES.WORDPRESS} {...props}/>}/>
        </Switch>
      </div>
    )
}

export default OnboardingInstallStep



// WEBPACK FOOTER //
// ./src/layouts/OnboardingInstallStep/index.js